import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { UserService } from '@core/services/user.service';
import { KeysEstaticas } from '@shared/constantes/KeysStaticas';

export const HomeGuard: CanActivateFn = (route, state): boolean | UrlTree => {
    const user = inject(UserService);
    const router = inject(Router);

    const isCoordinadorIncidencias = user.getCoordinadorIncidencias() === true; // puede gestionar incidencias y ver indicadores
    const isGestorIncidencias = user.getGestorIncidencias() === true;
    const isTransportista = user.getPerfil() === KeysEstaticas.PERFIL_TRANSPORTE;

    // si es coordinador, redirigimos a otra ruta segura
    if (isCoordinadorIncidencias || isGestorIncidencias) {
        return router.createUrlTree(['/Reclamacion/BuscadorIncidencias']); // <- ajusta a tu landing
    }

    if (isTransportista) {
        return router.createUrlTree(['/CitaPrevia/BuscadorCitasPrevias']); // <- ajusta a tu landing
    }

    return true;
};
